<h2 class="text-xl font-bold mb-4">Kategorie korrekt</h2>

<div class="mb-6">
  <h3 class="text-lg font-semibold text-green-600 flex items-center mb-2">
    <span class="mr-2">✅</span> Akzeptieren, wenn:
  </h3>
  <ul class="list-disc ml-6 space-y-2">
    <li>Die zugewiesene Kategorie korrekt und klar verständlich ist.</li>
    <li>Die Kategorie für Nutzer logisch und leicht auffindbar ist.</li>
  </ul>
</div>

<div class="mb-6">
  <h3 class="text-lg font-semibold text-red-600 flex items-center mb-2">
    <span class="mr-2">❌</span> Ablehnen bzw. Änderung erforderlich, wenn:
  </h3>
  <ul class="list-disc ml-6 space-y-2">
    <li>Die Kategorie nicht zum Inhalt passt.</li>
    <li>Das Angebot unter einer anderen Kategorie besser auffindbar wäre.</li>
  </ul>
</div>

<div class="mt-4 p-4 bg-blue-50 rounded-lg">
  <p class="flex items-center text-blue-800">
    <span class="mr-2">➡</span>
    <span class="font-semibold">Best Practice:</span>
    Falls die Kategorie falsch ist, sollte der Benutzer eine passende aus einer
    Dropdown-Liste auswählen.
  </p>
</div>
